export type TopicsUrlState = {
  l1Id?: string | null;
  l2Id?: string | null;
  l3Id?: string | null;
  exam?: string | null;
  view?: string | null;
  path?: string | null;
  scope?: 'exam' | 'global' | null;
};

const TOPICS_L1_KEY = 'l1';
const TOPICS_L2_KEY = 'l2';
const TOPICS_L3_KEY = 'l3';
const TOPICS_EXAM_KEY = 'exam';
const TOPICS_VIEW_KEY = 'view';
const TOPICS_PATH_KEY = 'path';
const TOPICS_SCOPE_KEY = 'scope';

export const parseTopicsUrlState = (
  params: URLSearchParams
): TopicsUrlState => ({
  l1Id: params.get(TOPICS_L1_KEY),
  l2Id: params.get(TOPICS_L2_KEY),
  l3Id: params.get(TOPICS_L3_KEY),
  exam: params.get(TOPICS_EXAM_KEY),
  view: params.get(TOPICS_VIEW_KEY),
  path: params.get(TOPICS_PATH_KEY),
  scope: params.get(TOPICS_SCOPE_KEY) as TopicsUrlState['scope'],
});

export const applyTopicsUrlState = (
  params: URLSearchParams,
  state: TopicsUrlState
) => {
  const next = new URLSearchParams(params);
  if (state.l1Id) {
    next.set(TOPICS_L1_KEY, state.l1Id);
  } else {
    next.delete(TOPICS_L1_KEY);
  }
  if (state.l2Id) {
    next.set(TOPICS_L2_KEY, state.l2Id);
  } else {
    next.delete(TOPICS_L2_KEY);
  }
  if (state.l3Id) {
    next.set(TOPICS_L3_KEY, state.l3Id);
  } else {
    next.delete(TOPICS_L3_KEY);
  }
  if (state.exam) {
    next.set(TOPICS_EXAM_KEY, state.exam);
  } else {
    next.delete(TOPICS_EXAM_KEY);
  }
  if (state.view) {
    next.set(TOPICS_VIEW_KEY, state.view);
  } else {
    next.delete(TOPICS_VIEW_KEY);
  }
  if (state.path) {
    next.set(TOPICS_PATH_KEY, state.path);
  } else {
    next.delete(TOPICS_PATH_KEY);
  }
  if (state.scope) {
    next.set(TOPICS_SCOPE_KEY, state.scope);
  } else {
    next.delete(TOPICS_SCOPE_KEY);
  }
  return next;
};

export const clearTopicsUrlState = (params: URLSearchParams) => {
  const next = new URLSearchParams(params);
  next.delete(TOPICS_L1_KEY);
  next.delete(TOPICS_L2_KEY);
  next.delete(TOPICS_L3_KEY);
  next.delete(TOPICS_EXAM_KEY);
  next.delete(TOPICS_VIEW_KEY);
  next.delete(TOPICS_PATH_KEY);
  next.delete(TOPICS_SCOPE_KEY);
  return next;
};
